import { platformCRMCardsOne, platformCRMCardsTwo } from './dashboard-platforms-section.constant';


export const  getPlatformCRMCardsOne = (loginUserRolePermissions: any = []) => {
  const platformCRMCards =  platformCRMCardsOne?.map((item: any) => {
    const resource = loginUserRolePermissions?.find((dataItem: any) => dataItem?.resource === item?.key);
    const resourceItem = item?.sections?.map((dataItem: any) => {
        const isShowResource= resource?.subresources?.find((permission: any) => permission?.resource === dataItem?.sectionsName)
        return{
            ...dataItem,
            isShowSubCard: isShowResource?.scopes?.read ? true : false,
        }
    });
    const isShowCard= resourceItem?.find((dataItem: any ) => dataItem?.isShowSubCard);
    return {
        ...item,
        sections: resourceItem,
        isShowCard: isShowCard?.isShowSubCard
    };
  });
  return platformCRMCards;
}

export const  getPlatformCRMCardsTwo = (loginUserRolePermissions: any =[]) => {
  const platformCRMCards =  platformCRMCardsTwo?.map((item: any) => {
    const resource = loginUserRolePermissions?.find((dataItem: any) => dataItem?.resource === item?.key);
    const resourceItem = item?.sections?.map((dataItem: any) => {
        const isShowResource= resource?.subresources?.find((permission: any) => permission?.resource === dataItem?.sectionsName)
        return{
            ...dataItem,
            isShowSubCard: isShowResource?.scopes?.read ? true : false,
        }
    });
    const isShowCard= resourceItem?.find((dataItem: any) => dataItem?.isShowSubCard);
    return {
        ...item,
        sections: resourceItem,
        isShowCard: isShowCard?.isShowSubCard
    };
  });
  return platformCRMCards;
}